import styled from '@emotion/styled';
interface IProps {
	gap: string;
	error: boolean;
}
export const Container = styled.div<IProps>`
	display: flex;
	flex-direction: column;
	gap: ${(props: IProps) => props.gap};
	width: 100%;
	height: 100%;
	input {
		border-color: ${(props: IProps) => (props.error ? 'red' : '')};
	}
	.dropdown-container {
		border-color: ${(props: IProps) => (props.error ? 'red' : '')};
	}
`;

export const ErrorMsg = styled.p`
	font-size: ${(props) => props.theme.fontSize.size2xs};
	color: red;
`;

export const Label = styled.label`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
